import { render, staticRenderFns } from "./ConflictsModal.vue?vue&type=template&id=469cfe66&scoped=true&"
import script from "./ConflictsModal.vue?vue&type=script&lang=js&"
export * from "./ConflictsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469cfe66",
  null
  
)

export default component.exports